export default __webpack_public_path__ + "static/media/Arjun Joshi.f6a59ced.jpeg";